var map = {
	"./cyberpunkLogin1.webp": 26831,
	"./cyberpunkLogin2.webp": 33838,
	"./cyberpunkLogin3.webp": 29865,
	"./cyberpunkLogin4.webp": 69712,
	"./cyberpunkLogin5.webp": 95475
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42999;